import { Flex } from "rebass";
import Close from "../../icons/Close";
import Tooltip from "./Tooltip";
const TabButton = ({ isActive, activeIcon, tooltip, sx, ...props }) => {
  return (
    <Tooltip content={isActive ? "" : tooltip || ""}>
      <Flex
        height={"100%"}
        justifyContent={"center"}
        alignItems={"center"}
        sx={{
          width: "40px",
          ...(isActive && {
            backgroundColor: "#232323",
            color: "#fff",
          }),
          cursor: "pointer",
          ...sx,
        }}
        {...props}
      >
        {!isActive ? activeIcon : <Close style={{ width: 18 }} />}
      </Flex>
    </Tooltip>
  );
};

export default TabButton;
